import { ReactNode, useEffect, useState } from "react";

interface DeferredAppMountProps {
  children: ReactNode;
  delay?: number;
  timeout?: number;
}

export const DeferredAppMount = ({ children, delay = 800, timeout = 2500 }: DeferredAppMountProps) => {
  const [canMount, setCanMount] = useState(false);

  useEffect(() => {
    let cancelScheduledMount: (() => void) | undefined;

    const scheduleMount = () => {
      if (typeof window.requestIdleCallback === "function") {
        const idleId = window.requestIdleCallback(() => setCanMount(true), { timeout });
        cancelScheduledMount = () => window.cancelIdleCallback(idleId);
        return;
      }

      const fallbackId = window.setTimeout(() => setCanMount(true), 1);
      cancelScheduledMount = () => window.clearTimeout(fallbackId);
    };

    const delayId = window.setTimeout(scheduleMount, delay);
    return () => {
      window.clearTimeout(delayId);
      cancelScheduledMount?.();
    };
  }, [delay, timeout]);

  if (!canMount) return null;

  return <>{children}</>;
};
